export default __webpack_public_path__ + "static/media/icon-tzkt.afc775ac.png";